import React from "react";
import { useState, useRef, useEffect } from "react";
import englishImg from "../assets/img/EN-Eid-Al-Fitr-No-Text.jpg";
import arabicImg from "../assets/img/AR-Eid-Al-Fitr-No-Text.jpg";

import englishImg2 from "../assets/img/EN-Option1.jpg";
import arabicImg2 from "../assets/img/AR-Option1.jpg";
import Footer from "./Footer";
import HomeNav from "./Nav";

import axios from "axios";

import download from "../assets/img/download.svg";

function Cards() {
  const canvasRef = useRef(null);
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [size, setSize] = useState(arabicImg2);
  const [language, setLanguage] = useState(2)
  
  useEffect(() => {
    drawCanvas()
  }, [size,name,position,language]);
 

  const handleNameChange = (event) => {
    setName(event.target.value);
    drawCanvas();
  };

  const handlePositionChange = (event) => {
    setPosition(event.target.value);
    drawCanvas();
  };

  const drawCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    if(size == englishImg){
      img.src = size;
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        ctx.textAlign = "right";
        ctx.fillStyle = "white";
        ctx.font = "500 55px Lato-Semibold";
        ctx.fillText(name, canvas.width - 121, canvas.height - 220);
        ctx.font = "45px Lato-Regular";
      ctx.fillText(position, canvas.width - 121, canvas.height - 150);
      }}
      else if(size == englishImg2){
        img.src = size;
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          ctx.textAlign = "right";
          ctx.fillStyle = "white";
          ctx.font = "500 40px Lato-Semibold";
          ctx.fillText(name, canvas.width - 70, canvas.height - 205);
          ctx.font = "500 40px Lato-Regular";
          ctx.fillText(position, canvas.width - 70, canvas.height - 150);
        };
      }
    else if(size == arabicImg){
      img.src = size;
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        ctx.textAlign = "right";
        ctx.fillStyle = "white";
        ctx.font = "500 50px LyonArabicText-Semibold";
        ctx.fillText(name, canvas.width - 121, canvas.height - 220);
        ctx.font = "500 50px LyonArabicText-Regular";
        ctx.fillText(position, canvas.width - 121, canvas.height - 150);
      };
    }
    else if(size == arabicImg2){
      img.src = size;
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        ctx.textAlign = "right";
        ctx.fillStyle = "white";
        ctx.font = "500 40px LyonArabicText-Semibold";
        ctx.fillText(name, canvas.width - 70, canvas.height - 215);
        ctx.font = "500 40px LyonArabicText-Regular";
        ctx.fillText(position, canvas.width - 70, canvas.height - 150);
      };
    }
   
  };

  const handleDownload = async () => {
    const canvas = canvasRef.current;
    const link = document.createElement("a");
    link.download = "d360-eid-card.png";
    link.href = canvas.toDataURL();
    link.click();

    const webhookUrl =
       "https://hooks.slack.com/services/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";


var dateObj = new Date();
var month = dateObj.getUTCMonth() + 1; //months from 1-12
var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    
    var screen
  if (size == englishImg || size == arabicImg) {
   screen = "Fireworks";
  } else {
    screen = "Airplane";
 }
const time = dateObj.toLocaleString("en-US", {
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: true,
  timeZoneName: "short",
});

   var newdate = day + "-" + month + "-" + year;
     const data = {
       blocks: [
         {
           type: "header",
           text: {
             type: "plain_text",
             text: "D360 Cards - Eid",
             emoji: true,
           },
         },
         {
           type: "section",
           fields: [
             {
               type: "mrkdwn",
               text: "*Type:*\n Eid 2025",
             },
           ],
         },
         {
           type: "section",
           fields: [
             {
               type: "mrkdwn",
               text: `*Name:*\n${name}`,
             },
             {
               type: "mrkdwn",
               text: `*Nickname:*\n${position}`,
             },
           ],
         },
         {
           type: "section",
           fields: [
             {
               type: "mrkdwn",
               text: `*When:*\n${newdate}`,
             },
             {
               type: "mrkdwn",
               text: `*Time:*\n${time}`,
             },
           ],
         },
         {
           type: "section",
           fields: [
             {
               type: "mrkdwn",
               text: `*Language:*\n${language == 1 ? "English" : "Arabic"}`,
             },
             {
               type: "mrkdwn",
               text: `*Design:*\n${screen}`,
             },
           ],
         },
       ],
     };
    
   

     let res = await axios.post(webhookUrl, JSON.stringify(data), {
       withCredentials: false,
       transformRequest: [
         (data) => {
           return data;
         },
       ],
     });
  };

  const handleSelect = (e) => {
    setSize(e.target.value);
    setName("");
    setPosition("");
  }
  
  const handleSelectLang = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
    
    // Update the card design based on new language
    if (selectedLanguage == 1) {
      setSize(size === arabicImg ? englishImg : englishImg2);
    } else {
      setSize(size === englishImg ? arabicImg : arabicImg2);
    }
    
    setName("");
    setPosition("");
  }

  return (
    <div dir="rtl">
      <HomeNav />
      <div  className="container page-up ">
      <div className="bg-home">
      {/* <h4 className="text-center">اختر تفاصيل البطاقة</h4>
      <h4 className="text-center">Choose the card details</h4> */}
      </div>
        <div style={{marginTop:"30px"}} className="row ">
          <div className="col-md col-lg mb-4">
              <div className="text-center container align-items-center justify-content-center ">
                {/* <img
                  src={size}
                  className="card-img-top "
                  style={{ borderRadius:"15px"}}
                  alt="Image 1"
                /> */}
              <canvas style={{ borderRadius:"15px", width: size == englishImg || size == arabicImg ? "100%" : "100%"}} className="card-img-top " ref={canvasRef}  />

              </div>
          </div>
          <div className="col-md col-lg mb-4">
          <div className="row mt-3">
        <div className="col-md col-lg mx-auto">
       
            <div className="card-body">

            {/* Card Design Selection */}
<label htmlFor="size" className="form-label">
  <span className="arabic-text">اختر تصميم البطاقة </span>
  <span className="english-text">  Choose card design</span>
</label>
<div className="mb-3 mt-3">
  <div className="d-flex gap-2">
    {/* Option 1 */}
    <label className="flex-grow-1 position-relative">
      <input
        type="radio"
        name="cardDesign"  // Changed to unique name
        value={language == 1 ? englishImg2 : arabicImg2} 
        className="visually-hidden"
        onChange={handleSelect}
        checked={size === (language == 1 ? englishImg2 : arabicImg2)}
      />
      <span className="radio-option english-text">
        Option 1
      </span>
    </label>

    {/* Option 2 */}
    <label className="flex-grow-1 position-relative">
      <input
        type="radio"
        name="cardDesign"  // Changed to unique name
        value={language == 1 ? englishImg : arabicImg}
        className="visually-hidden"
        onChange={handleSelect}
        checked={size === (language == 1 ? englishImg : arabicImg)}
      />
      <span className="radio-option english-text">
        Option 2
      </span>
    </label>
  </div>
</div>

{/* Language Selection */}
<label htmlFor="size" className="form-label">
<span className="arabic-text"> اختر لغة البطاقة  </span>
<span className="english-text">  Choose card language </span>

</label>
<div className="mb-3 mt-3">
  <div className="d-flex gap-2">
    {/* Option 1 */}
    <label className="flex-grow-1 position-relative">
      <input
        type="radio"
        name="cardLanguage"  // Changed to unique name
        value="2"
        className="visually-hidden"
        onChange={handleSelectLang}
        checked={language == 2}
      />
      <span className="radio-option arabic-text">
        عربي
      </span>
    </label>

    {/* Option 2 */}
    <label className="flex-grow-1 position-relative">
      <input
        type="radio"
        name="cardLanguage"  // Changed to unique name
        value="1"
        className="visually-hidden"
        onChange={handleSelectLang}
        checked={language == 1}
      />
      <span className="radio-option english-text">
        English
      </span>
    </label>
  </div>
</div>
              <div className="mb-3 mt-3">
                <label htmlFor="name" className="form-label">
                <span className="arabic-text">  ادخل اسمك  </span>
                <span className="english-text">    Enter your name </span>
          
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  value={name}
                  onChange={handleNameChange}
                />
              </div>
              <div className=" last-input" >
                <label htmlFor="position" className="form-label">
                <span className="arabic-text"> ادخل كنيتك </span>
                <span className="english-text">  Enter your nickname (optional) </span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="position"
                  value={position}
                  onChange={handlePositionChange}
                />
              </div>
            </div>
            <div id="download-button" className="text-center ">
              <button className="btn btn-primary bb" onClick={handleDownload}>
              <img src={download} width={20}/>
              </button> 
            </div>
        </div>
      </div>
      </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default Cards;
